var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:{
        'status--on': _vm.isOn
    }},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.statusText))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }